/* Copyright (c) 2023 CLOUDPILOTS Software & Consulting GmbH */

import ClassIcon from '@material-ui/icons/Class';
import DashboardIcon from '@material-ui/icons/Dashboard';
import ProductIcon from '@material-ui/icons/LocalOffer';
import PeopleIcon from '@material-ui/icons/People';

const menu = [
  {
    title: 'Dashboard',
    icon: DashboardIcon,
    to: '/',
    id: 'dashboard',
    exact: true,
  },
  {
    id: 'subscriptions',
    title: 'Subscriptions',
    icon: ProductIcon,
    to: '/subscriptions',
  },
  {
    id: 'customers',
    title: 'Customers',
    icon: PeopleIcon,
    to: '/customers',
  },
  {
    id: 'prices',
    title: 'Prices',
    icon: ProductIcon,
    to: '/prices',
  },
  {
    id: 'plans',
    title: 'Plans',
    icon: ClassIcon,
    to: '/plans',
  },
  {
    id: 'billing',
    title: 'Billing',
    icon: ClassIcon,
    to: '/billing',
  },
  {
    id: 'invoices',
    title: 'Invoices',
    icon: ClassIcon,
    to: '/invoices',
  },
  {
    id: 'invoiceImports',
    title: 'Invoice Imports',
    icon: ClassIcon,
    to: '/invoiceImports',
  },
];

const defaultItem = {
  title: 'Dashboard',
  icon: DashboardIcon,
  to: '/',
  id: 'dashboard',
};

export { menu, defaultItem };
